import { useQuery } from 'react-query';
import { IPaginationParams } from '../../../types';
import { ISchoolTransportationFilterParams } from '../../types';
import {
  getAllSchoolTransportationByLicenseAsync,
  getAllSchoolTransportationCountAsync,
  getSchoolTransportationSummaryAsync,
} from '../../index';

export const SCHOOL_TRANSPORTATION_KEYS = {
  ALL: 'schoolTransportation',
  LIST: 'list',
  COUNT: 'count',
  SUMMARY: 'summary',
};

export const useGetSchoolTransportationSummaryQuery = () => {
  return useQuery(
    [SCHOOL_TRANSPORTATION_KEYS.ALL, SCHOOL_TRANSPORTATION_KEYS.SUMMARY],
    getSchoolTransportationSummaryAsync,
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    },
  );
};

export const useGetAllSchoolTransportationByLicenseQuery = (
  pagination: IPaginationParams,
  filter: ISchoolTransportationFilterParams,
  enabled = true,
) => {
  return useQuery(
    [
      SCHOOL_TRANSPORTATION_KEYS.ALL,
      SCHOOL_TRANSPORTATION_KEYS.LIST,
      pagination,
      filter,
    ],
    () => getAllSchoolTransportationByLicenseAsync(pagination, filter),
    {
      enabled,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    },
  );
};

export const useGetSchoolTransportationCountQuery = (
  filter: ISchoolTransportationFilterParams,
) => {
  return useQuery(
    [SCHOOL_TRANSPORTATION_KEYS.ALL, SCHOOL_TRANSPORTATION_KEYS.COUNT, filter],
    () => getAllSchoolTransportationCountAsync(filter),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    },
  );
};
